export default "__VITE_ASSET__9BEeetfK__"